import { ScheduledGlueJob } from '../../services/schedule-utils'

const buildGlueRunsUrl = (job: ScheduledGlueJob) =>
    `https://${job.aws_region}.console.aws.amazon.com/gluestudio/home?region=${encodeURIComponent(job.aws_region)}#/editor/job/${encodeURIComponent(job.job_name)}/runs`

const ExternalLinkIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M15 3h6v6M10 14 21 3" />
        <path d="M21 14v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6" />
    </svg>
)

export const AwsEtlLinks = ({ jobs, sourceName }: { jobs: ScheduledGlueJob[]; sourceName: string }) => {
    const availableJobs = jobs.filter(job => job.job_name && job.aws_region)
    if (!availableJobs.length) return null
    if (availableJobs.length === 1) {
        const job = availableJobs[0]
        const label = `View ${job.job_name} runs in AWS (opens in a new tab)`
        return <span className="source-aws-links">
            <a className="source-aws-link" href={buildGlueRunsUrl(job)} target="_blank" rel="noopener noreferrer" title={label} aria-label={label} onClick={event => event.stopPropagation()}>
                <ExternalLinkIcon />
            </a>
        </span>
    }
    return <details className="source-aws-links" onClick={event => event.stopPropagation()}>
        <summary className="source-aws-link" title={`View ${sourceName} ETL runs in AWS`} aria-label={`View ${sourceName} ETL runs in AWS`}>
            <ExternalLinkIcon />
        </summary>
        <div className="source-aws-menu">
            {availableJobs.map(job => <a key={`${job.aws_region}:${job.job_name}`} href={buildGlueRunsUrl(job)} target="_blank" rel="noopener noreferrer" title={`View runs in ${job.aws_region} (opens in a new tab)`}>
                {job.job_name}
            </a>)}
        </div>
    </details>
}
